module.exports = __webpack_public_path__ + "img/ebook-ipad_mediurs.45ac5f29.png";